import TelLink from "@/modules/share/ui/tel-link";

// 고객 화면 sticky 머리의 회사명·전화 — 폰은 한 줄(전화 터치 영역 40px 가 회사명을 덮지 않고 머리도 안 커진다), md 이상은 두 줄 그대로.
export const HEAD_ORG_CLASS = "flex min-w-0 flex-1 items-center gap-x-2 md:block";

const CustomerHeadOrg = ({ name, tel }: { name: string; tel?: string | null }) => (
  <div className={HEAD_ORG_CLASS} data-testid="customer-head-org">
    <p className="min-w-0 truncate text-sm font-semibold">{name}</p>
    {tel && <TelLink tel={tel} />}
  </div>
);

export default CustomerHeadOrg;
